export default __webpack_public_path__ + "static/media/groundplan_s_63a.13b790e8.png";